export default __webpack_public_path__ + "static/media/logo.0f44aa74.png";